import { Injectable } from '@angular/core';
import { FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable()
export class ValidatorCustomService {

  constructor() { }

  optionalValidator(validators?: (ValidatorFn | null | undefined)[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        return control.value ? Validators.compose(validators)(control) : null;
    }
  }

  isFieldValid(field: string, formGroup: FormGroup) {
    return !formGroup.get(field).valid && formGroup.get(field).touched;
  }

  displayFieldCss(field: string, formGroup: FormGroup) {
    return {
      'has-error': this.isFieldValid(field, formGroup),
      'has-feedback': this.isFieldValid(field, formGroup)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      // console.log(field);
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/validator-custom.service.ts